import React, { useEffect, useMemo } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/layout/Header';
import Footer from '../../../components/layout/Footer';
import { SEMICON_MECH } from '../../../data/studioLabs';
import { loadWarpageSnapshot } from './warpageMath';
import { loadPeelSnapshot } from './peelModel';
import './SemiconMech.css';

const COPY = {
  warpage: 'Cool a QFN-like stack. The strip cups. Change EMC, die, attach — watch the die side lift.',
  'peel-shear': 'Set cure, plasma, adhesive. Pull until the joint lets go. Main effects, not folklore.',
  defence: 'Walk into stand-up with bow and peel in your pocket. The AI is the sceptical senior.',
};

const SemiconOverview = () => {
  const warpage = useMemo(() => loadWarpageSnapshot(), []);
  const peel = useMemo(() => loadPeelSnapshot(), []);

  useEffect(() => {
    document.documentElement.classList.add('qn-home-html');
    document.body.classList.add('qn-home-body');
    return () => {
      document.documentElement.classList.remove('qn-home-html');
      document.body.classList.remove('qn-home-body');
    };
  }, []);

  return (
    <div className="sm-lab">
      <Header />
      <main className="sm-main">
        <Link to="/virtuallabs" className="sm-back">← All labs</Link>
        <p className="sm-kicker">Back-end line · mechanical</p>
        <h1>The package is still hot and already fighting you</h1>
        <p className="sm-lead">
          Cool-down bow of a QFN-like stack (CTE beam, die stress order-of-magnitude, spec vs body size).
          Then a 90° die-attach peel you actually pull, with main effects and failure-mode reading.
          Then a stand-up graded on mechanism, evidence, and one Monday action — the way a packaging senior listens.
        </p>
        {(warpage || peel) && (
          <div className="sm-metrics">
            {warpage && <span className="sm-metric"><b>Last bow</b> · {Number(warpage.bowUm).toFixed(1)} µm</span>}
            {peel?.lastPeel != null && <span className="sm-metric"><b>Last peel</b> · {peel.lastPeel.toFixed(2)} N/mm</span>}
          </div>
        )}
        <div className="sm-hero-benches">
          {SEMICON_MECH.benches.map((b, i) => (
            <Link key={b.id} to={b.path} className="sm-card" style={i === 0 ? { minHeight: 180 } : undefined}>
              <em>Station {i + 1}</em>
              <h2>{b.title}</h2>
              <p>{COPY[b.id]}</p>
            </Link>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default SemiconOverview;
